import React from 'react';

import { css } from '@emotion/css';
import { Button } from 'antd';

import { Modal } from 'components/Modal/Modal';

import { CloseableModalProps } from 'utils/asyncModal';

import { NewLineToParagraph } from './NewLineToParagraph';

export interface ItemLocationNotesViewModalProps extends CloseableModalProps<void> {
  title: string;
  notes: string;
  onClose: () => void;
}

export function ItemLocationNotesViewModal({ title, notes, onClose }: ItemLocationNotesViewModalProps) {
  return (
    <Modal
      visible
      width={800}
      onCancel={() => {
        onClose();
      }}
      title={`Item Location Notes - ${title}`}
      destroyOnClose
      footer={
        <>
          <Button onClick={() => onClose()}>Close</Button>
        </>
      }
    >
      <div
        className={css`
          display: flex;
          gap: 16px;
          height: 350px;
          flex: 1;
          flex-direction: column;
        `}
      >
        <NewLineToParagraph note={notes} />
      </div>
    </Modal>
  );
}
